/* eslint-disable react-hooks/exhaustive-deps */
import { DateRangePicker } from 'app/ComponentLibrary/DateRangeNew';
import { isNullOrUndefined } from 'app/helpers/objectHelpers';
import { isEmpty } from 'lodash';
import moment from 'moment';
import React from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { usePromiseTracker } from 'react-promise-tracker';
import { useSelector } from 'react-redux';
import { selectIsEditMod, selectIsEmiLmoDisabled } from 'store/redux-store/placement-mods/selectors';
import { makeStyles } from 'tss-react/mui';
import { compareDates } from '../../ModificationsUtils';

const useStyles = makeStyles()(() => ({
  inputFields: {
    minWidth: '226px',
    height: '53px',
  },
}));

export const LateMoveOutDate = () => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const { control, formState: { errors }, setValue, clearErrors } = useFormContext();
  const value: Date | string | null | undefined = useWatch({ name: 'lateMoveOutDate' });
  const moveOutDate: Date | string | null | undefined = useWatch({ name: 'moveOutDate' });
  const isModEdit = useSelector(selectIsEditMod);
  const { promiseInProgress: isSaveModApiCalling } = usePromiseTracker({ area: 'save-mod-api', delay: 0 });
  const isEmiLmoDisabled = useSelector(selectIsEmiLmoDisabled);

  const checkDateValidation = lateMoveOutDate => {
    const currentMoveOutDate = moveOutDate;
    if (currentMoveOutDate && lateMoveOutDate) {
      if (compareDates(currentMoveOutDate, lateMoveOutDate)) {
        setValue('lmoNumberOfDays', '', { shouldDirty: true });
        return t('placement.placementMods.moveOutDateError');
      }
    }
    setValue(
      'lmoNumberOfDays',
      isNullOrUndefined(lateMoveOutDate) || isEmpty(lateMoveOutDate)
        ? ''
        : moment(lateMoveOutDate).diff(moveOutDate, 'days'),
      { shouldDirty: false },
    );
    clearErrors('lateMoveOutDate');
    clearErrors('lmoNumberOfDays');
    return null;
  };

  return (
    <Controller
      control={control}
      name={'lateMoveOutDate'}
      rules={{
        validate: checkDateValidation,
      }}
      render={({ field: { onChange, value, ...rest } }) => {
        const lateMoveOutDate = moment(value ?? null);
        return (
          <React.Fragment>
            <DateRangePicker
              onChange={newValue => {
                if (newValue.startDate !== undefined) {
                  const newDate = moment(newValue.startDate);
                  const setTo = newDate.isValid() ? moment(newDate).format('YYYY-MM-DDTHH:mm:ss') : null;

                  onChange(setTo);
                } else {
                  onChange(null);
                }
              }}
              open={false}
              quickSelect={false}
              variant="filled"
              single
              placeholder="Late Move Out Date"
              useMaxWidth={true}
              labelClass={classes.inputFields}
              trailingIconShow={true}
              className={classes.inputFields}
              actionBar={false}
              clickAway={true}
              readOnly={!isModEdit || isNullOrUndefined(moveOutDate) || isEmpty(moveOutDate) || isEmiLmoDisabled}
              keepClickAwayVal={true}
              isDisabled={isSaveModApiCalling}
              initialDateRange={{
                startDate: lateMoveOutDate.isValid()
                  ? new Date(lateMoveOutDate.format('YYYY-MM-DDTHH:mm:ss'))
                  : undefined,
                endDate: lateMoveOutDate.isValid()
                  ? new Date(lateMoveOutDate.format('YYYY-MM-DDTHH:mm:ss'))
                  : undefined,
                useLabelAsValue: true,
              }}
              error={!!errors?.lateMoveOutDate}
              helperText={!isNullOrUndefined(errors?.lateMoveOutDate) ? errors?.lateMoveOutDate?.message : undefined}
              {...rest}
            />
          </React.Fragment>
        );
      }}
    />
  );
};
